import React, { useEffect, useState } from 'react';
import { API } from 'aws-amplify';
import { SHA256 } from 'crypto-js';
import Loader from '../../../components/Loader';
import { getCurrentUserEmail } from '../../../utils/auth/authenticatedUser';

export default function PreAuthRequestAndRedirect(props) {
  const { dataProvider: { id: fiId, provider: providerId }, scoringRequest } = props;
  const { clientId, requestId } = scoringRequest;
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    async function fetchData() {
      const userEmail = await getCurrentUserEmail();
      const user = SHA256(userEmail).toString();
      const redirectUrl = [window.location.origin, 'auth'].join('/');
      const result = await API.post('Auth', '/', {
        body: {
          user,
          providerId,
          clientId,
          requestId,
          fiId,
          step: 'preAuth',
          redirectUrl,
        },
      });
      const { sessionId } = result;
      localStorage.setItem(sessionId, JSON.stringify({
        providerId,
        redirectUrl,
        sessionId,
        fiId,
        scoringRequest,
      }));
      if (!result || result.error || !result.url) {
      // eslint-disable-next-line no-console
        console.error('Unable to run PAR request', result.error);
        setHasError(true);
        return;
      }
      window.location.href = result.url;
    }
    fetchData();
  });
  if (hasError) {
    return (<div>An error occurred</div>);
  }
  return (<Loader />);
}
